document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sych-pm]').forEach(function (root) {
    /* ---------- Gallery ---------- */

    /* Two galleries can be in the page: the product's own media for desktop, and
       the product's mobile catalogue (a custom.mobile_gallery metafield) below
       991px. They hold different shots in different numbers, so this is a swap
       rather than a re-crop, and only the one on show is ever initialised —
       Swiper cannot measure a display:none element, and a second live instance
       would put stale slides in front of the lightbox. */

    var galleryMq = window.matchMedia('(max-width: 991px)');
    var hasSplitGallery = !!root.querySelector('[data-pm-main][data-pm-view="mobile"]');
    var mainSwiper = null;
    var thumbsSwiper = null;
    var galleryView = '';

    // With one gallery every view resolves to it. With two the match has to be
    // exact, or a view whose thumbs were skipped (a single slide needs none)
    // would borrow the other view's strip.
    function forView(selector, wanted) {
      if (!hasSplitGallery) return root.querySelector(selector);
      return root.querySelector(selector + '[data-pm-view="' + wanted + '"]');
    }

    function buildGallery(wanted) {
      if (wanted === galleryView) return;
      galleryView = wanted;

      // Detach the tap-to-zoom handlers while they still point at slides that
      // are in the DOM, before the slide list underneath them is replaced.
      armZoom(false);

      if (mainSwiper) { mainSwiper.destroy(true, true); mainSwiper = null; }
      if (thumbsSwiper) { thumbsSwiper.destroy(true, true); thumbsSwiper = null; }

      var mainEl = forView('[data-pm-main]', wanted);
      var thumbsEl = forView('[data-pm-thumbs]', wanted);

      refreshSlides(mainEl);
      root.setAttribute('data-pm-gallery-view', wanted);

      if (!window.Swiper || !mainEl) return;

      if (thumbsEl) {
        thumbsSwiper = new Swiper(thumbsEl, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          watchSlidesProgress: true
        });
      }

      mainSwiper = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 8,
        rewind: true,
        navigation: {
          prevEl: root.querySelector('.sych-pm__stage .sych-pm__nav--prev'),
          nextEl: root.querySelector('.sych-pm__stage .sych-pm__nav--next')
        },
        thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined
      });

      armZoom(wanted === 'mobile');
    }

    // Bound once over both strips and read through the live variable, so they
    // keep driving whichever instance the current breakpoint built.
    root.querySelectorAll('.sych-pm__thumb-prev').forEach(function (btn) {
      btn.addEventListener('click', function () { if (mainSwiper) mainSwiper.slidePrev(); });
    });
    root.querySelectorAll('.sych-pm__thumb-next').forEach(function (btn) {
      btn.addEventListener('click', function () { if (mainSwiper) mainSwiper.slideNext(); });
    });

    /* ---------- Popup ---------- */

    var popup = root.querySelector('[data-pm-popup]');
    var popupImg = root.querySelector('[data-pm-popup-img]');
    // Scoped to the gallery currently built, not to the whole section: with both
    // galleries in the DOM, root-wide lists would put the hidden set's images in
    // the lightbox and throw the indexes off.
    var slideEls = [];
    var slides = [];

    var popupIndex = 0;
    var popupOpener = null;
    // Bumped on every slide change so a full-size image that finishes loading
    // after the user has already moved on cannot overwrite the current one.
    var popupToken = 0;

    function refreshSlides(mainEl) {
      var scope = mainEl || root;
      slideEls = Array.prototype.slice.call(scope.querySelectorAll('.sych-pm__slide'));
      slides = Array.prototype.slice.call(scope.querySelectorAll('.sych-pm__slide-img'));
      // Only real media opens the lightbox; the placeholder slide has nothing to show.
      zoomSlides = slideEls.filter(function (slide) {
        return !!slide.querySelector('.sych-pm__slide-img[data-pm-full]');
      });
      popupIndex = 0;
    }

    function showPopupSlide(index) {
      if (!slides.length || !popupImg) return;
      popupIndex = (index + slides.length) % slides.length;
      popupToken += 1;

      var img = slides[popupIndex];
      // Read at open time rather than at boot: these are lazy and responsive, so
      // currentSrc only settles once the browser has picked a candidate. Whatever
      // it picked is already decoded, which is what lets the popup paint on the
      // frame it opens.
      var shown = img.currentSrc || img.src || '';
      var full = img.getAttribute('data-pm-full') || '';

      popupImg.src = shown;
      popupImg.alt = img.alt || '';

      if (!full || full === shown) return;

      // Swap in the larger file only once it has decoded, so the upgrade is never
      // visible as a blank frame.
      var token = popupToken;
      var pre = new Image();
      pre.onload = function () {
        if (token === popupToken) popupImg.src = full;
      };
      pre.src = full;
    }

    function openPopup(index, opener) {
      if (!popup) return;
      if (typeof index !== 'number' || index < 0) index = mainSwiper ? mainSwiper.realIndex : 0;
      popupOpener = opener || null;
      showPopupSlide(index);
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sych-pm-popup-open');

      var closeBtn = popup.querySelector('.sych-pm__popup-close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function closePopup() {
      if (!popup) return;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sych-pm-popup-open');

      if (popupOpener) {
        popupOpener.focus({ preventScroll: true });
        popupOpener = null;
      }
    }

    root.querySelectorAll('[data-pm-popup-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    var popupPrev = root.querySelector('.sych-pm__popup-prev');
    var popupNext = root.querySelector('.sych-pm__popup-next');
    if (popupPrev) popupPrev.addEventListener('click', function () { showPopupSlide(popupIndex - 1); });
    if (popupNext) popupNext.addEventListener('click', function () { showPopupSlide(popupIndex + 1); });

    document.addEventListener('keydown', function (e) {
      if (!popup || !popup.classList.contains('is-open')) return;
      if (e.key === 'Escape') closePopup();
      if (e.key === 'ArrowLeft') showPopupSlide(popupIndex - 1);
      if (e.key === 'ArrowRight') showPopupSlide(popupIndex + 1);
    });

    /* ---------- Popup: swipe between images ---------- */

    // The arrows are a small target on a phone, and a full-screen image that does
    // not answer a swipe reads as broken. The 40px threshold is well clear of a
    // tap, so a tap on the overlay still closes as before.
    if (popup) {
      var swipeX = 0;
      var swipeY = 0;
      var swiping = false;

      popup.addEventListener('touchstart', function (e) {
        swiping = e.touches.length === 1;
        if (!swiping) return;
        swipeX = e.touches[0].clientX;
        swipeY = e.touches[0].clientY;
      }, { passive: true });

      popup.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;
        var touch = e.changedTouches[0];
        var dx = touch.clientX - swipeX;
        var dy = touch.clientY - swipeY;
        if (slides.length < 2) return;
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
        showPopupSlide(dx < 0 ? popupIndex + 1 : popupIndex - 1);
      }, { passive: true });
    }

    /* ---------- Mobile: tap a slide to open the lightbox ---------- */

    /* Desktop is deliberately left as it was — the stage is not clickable there —
       so the handlers and the ARIA go on and off with the breakpoint rather than
       being bound once and short-circuited inside. A slide that announces itself
       as a button at a width where tapping it does nothing is worse than no
       affordance at all. */

    var zoomOn = false;
    var tapX = 0;
    var tapY = 0;
    var tapMoved = false;

    // Filled by refreshSlides, which runs on every breakpoint swap.
    var zoomSlides = [];

    function onSlideTouchStart(e) {
      var touch = e.changedTouches[0];
      tapX = touch.clientX;
      tapY = touch.clientY;
      tapMoved = false;
    }

    function onSlideTouchMove(e) {
      // Swiper swallows the click that ends a drag, but only once the drag has
      // passed its own threshold; this catches the shorter moves that are still
      // a swipe rather than a tap.
      var touch = e.changedTouches[0];
      if (Math.abs(touch.clientX - tapX) > 10 || Math.abs(touch.clientY - tapY) > 10) tapMoved = true;
    }

    function onSlideClick(e) {
      if (tapMoved) {
        tapMoved = false;
        return;
      }
      openPopup(slides.indexOf(e.currentTarget.querySelector('.sych-pm__slide-img')), e.currentTarget);
    }

    function onSlideKeydown(e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      e.preventDefault();
      openPopup(slides.indexOf(e.currentTarget.querySelector('.sych-pm__slide-img')), e.currentTarget);
    }

    function armZoom(on) {
      // Nothing to open, nothing to arm — a placeholder-only gallery, or a build
      // that ran before the lightbox markup exists.
      if (on && (!popup || !zoomSlides.length)) on = false;
      if (on === zoomOn) return;
      zoomOn = on;

      zoomSlides.forEach(function (slide) {
        if (on) {
          slide.setAttribute('role', 'button');
          slide.setAttribute('tabindex', '0');
          slide.setAttribute('aria-haspopup', 'dialog');
          slide.setAttribute('aria-label', slide.getAttribute('data-pm-zoom-label') || '');
          slide.addEventListener('touchstart', onSlideTouchStart, { passive: true });
          slide.addEventListener('touchmove', onSlideTouchMove, { passive: true });
          slide.addEventListener('click', onSlideClick);
          slide.addEventListener('keydown', onSlideKeydown);
        } else {
          slide.removeAttribute('role');
          slide.removeAttribute('tabindex');
          slide.removeAttribute('aria-haspopup');
          slide.removeAttribute('aria-label');
          slide.removeEventListener('touchstart', onSlideTouchStart);
          slide.removeEventListener('touchmove', onSlideTouchMove);
          slide.removeEventListener('click', onSlideClick);
          slide.removeEventListener('keydown', onSlideKeydown);
        }
      });

      root.classList.toggle('sych-pm--zoomable', on);
    }

    buildGallery(galleryMq.matches ? 'mobile' : 'desktop');

    var onGalleryMqChange = function (e) { buildGallery(e.matches ? 'mobile' : 'desktop'); };
    if (galleryMq.addEventListener) galleryMq.addEventListener('change', onGalleryMqChange);
    else if (galleryMq.addListener) galleryMq.addListener(onGalleryMqChange);

    /* ---------- 360 drag viewer ---------- */

    var r360 = root.querySelector('[data-pm-360]');
    var open360 = null;

    if (r360) {
      var stage360 = r360.querySelector('[data-pm-360-stage]');
      var holder360 = r360.querySelector('[data-pm-360-lottie]');
      var bar360 = r360.querySelector('[data-pm-360-bar]');

      var cfg360 = {
        src: r360.dataset.lottie || '',
        // Served from the theme rather than jsdelivr, so the URL has to come
        // from Liquid — asset paths carry a theme id that differs per theme.
        player: r360.dataset.player || '',
        distance: parseFloat(r360.dataset.distance) || 600,
        invert: r360.dataset.invert === 'true',
        auto: r360.dataset.auto === 'true',
        autoSeconds: parseFloat(r360.dataset.autoSeconds) || 12,
        inertia: r360.dataset.inertia === 'true'
      };

      // `target` and `cur` are unbounded frame counts; only the value handed to the
      // animation gets wrapped, so spinning past either end never jumps back.
      var target360 = 0;
      var cur360 = 0;
      var prevTarget = 0;
      var vel360 = 0;
      var dragging360 = false;
      var lastX360 = 0;
      var lastFrame = 0;
      var idleAt = 0;
      var raf360 = null;
      var isLoaded360 = false;
      var anim360 = null;
      var frames360 = 0;
      var shownFrame360 = -1;

      /* The SVG build, and the same shared promise the scroll section uses.
         Standardising matters: window.lottie holds whichever build loaded last, so
         a page carrying both sections with different builds would leave one of
         them asking for a renderer that build does not contain. */
      function loadPlayer360() {
        if (window.lottie) return Promise.resolve(window.lottie);
        if (window.__sychLottiePlayer) return window.__sychLottiePlayer;
        // An empty src resolves to the current page, which would load the whole
        // document as a script and fail in a way that is hard to read.
        if (!cfg360.player) return Promise.reject(new Error('player url missing'));
        window.__sychLottiePlayer = new Promise(function (resolve, reject) {
          var s = document.createElement('script');
          s.src = cfg360.player;
          s.async = true;
          s.onload = function () { resolve(window.lottie); };
          // No retry — a failed CDN fetch fails the same way twice.
          s.onerror = function () { window.__sychLottiePlayer = null; reject(new Error('player')); };
          document.head.appendChild(s);
        });
        return window.__sychLottiePlayer;
      }

      function tick360(ts) {
        raf360 = requestAnimationFrame(tick360);

        var span = frames360;
        if (!span) return;

        var dt = lastFrame ? Math.min((ts - lastFrame) / 1000, 0.1) : 0;
        lastFrame = ts;
        if (!idleAt) idleAt = ts;
        if (!dt) return;

        if (dragging360) {
          var inst = (target360 - prevTarget) / dt;
          vel360 = vel360 * 0.5 + inst * 0.5;
        } else if (cfg360.inertia && Math.abs(vel360) > 0.05) {
          target360 += vel360 * dt;
          vel360 *= Math.pow(0.06, dt);
          idleAt = ts;
        } else {
          vel360 = 0;
          if (cfg360.auto && ts - idleAt > 1200) {
            target360 += (span / cfg360.autoSeconds) * dt;
          }
        }
        prevTarget = target360;

        cur360 += (target360 - cur360) * Math.min(1, dt * 14);

        var t = ((cur360 % span) + span) % span;

        /* The frames are already decoded images, so landing on one is a DOM swap
           rather than a seek — which is the whole reason this drags smoothly. Only
           worth doing when the rounded frame actually changed. */
        var f = Math.round(t);
        if (f >= span) f = 0;
        if (anim360 && f !== shownFrame360) {
          shownFrame360 = f;
          anim360.goToAndStop(f, true);
        }

        if (bar360) bar360.style.transform = 'scaleX(' + (t / span).toFixed(4) + ')';
      }

      function pointerX(e) {
        if (e.touches && e.touches.length) return e.touches[0].clientX;
        if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientX;
        return e.clientX;
      }

      function onDrag360Start(e) {
        if (e.button != null && e.button !== 0) return;
        dragging360 = true;
        vel360 = 0;
        lastX360 = pointerX(e);
        prevTarget = target360;
        stage360.classList.add('is-dragging', 'is-touched');
        if (e.pointerId != null && stage360.setPointerCapture) {
          try { stage360.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
        }
      }

      function onDrag360Move(e) {
        if (!dragging360 || !frames360) return;
        if (e.cancelable) e.preventDefault();

        var x = pointerX(e);
        var dx = x - lastX360;
        lastX360 = x;
        // one `distance` of travel is one full turn, whatever the frame count
        target360 += (dx / cfg360.distance) * frames360 * (cfg360.invert ? -1 : 1);
      }

      function onDrag360End(e) {
        if (!dragging360) return;
        dragging360 = false;
        idleAt = lastFrame;
        stage360.classList.remove('is-dragging');
        if (e && e.pointerId != null && stage360.releasePointerCapture) {
          try { stage360.releasePointerCapture(e.pointerId); } catch (err) { /* noop */ }
        }
      }

      if (window.PointerEvent) {
        stage360.addEventListener('pointerdown', onDrag360Start);
        stage360.addEventListener('pointermove', onDrag360Move, { passive: false });
        stage360.addEventListener('pointerup', onDrag360End);
        stage360.addEventListener('pointercancel', onDrag360End);
        stage360.addEventListener('pointerleave', onDrag360End);
      } else {
        stage360.addEventListener('mousedown', onDrag360Start);
        window.addEventListener('mousemove', onDrag360Move);
        window.addEventListener('mouseup', onDrag360End);
        stage360.addEventListener('touchstart', onDrag360Start, { passive: true });
        stage360.addEventListener('touchmove', onDrag360Move, { passive: false });
        stage360.addEventListener('touchend', onDrag360End);
        stage360.addEventListener('touchcancel', onDrag360End);
      }

      function ready360() {
        stage360.classList.remove('is-loading');
      }

      function fail360(reason) {
        stage360.classList.remove('is-loading');
        stage360.classList.add('is-failed');
        if (window.console) console.warn('[sych-pm] 360 Lottie failed to load:', reason);
      }

      /* Nothing is fetched until the popup is opened — the JSON carries every frame
         inline, so loading it up front would be megabytes spent on a popup most
         visitors never open. */
      function build360() {
        if (isLoaded360) return;
        isLoaded360 = true;

        if (!cfg360.src) {
          fail360('no Lottie file set');
          return;
        }

        var settled = false;
        // never leave the spinner up forever if neither event arrives
        var guard = setTimeout(function () {
          if (settled) return;
          settled = true;
          fail360('timed out after 15s — check the file name in Settings > Files');
        }, 15000);

        loadPlayer360().then(
          function (lottie) {
            if (settled) return;
            anim360 = lottie.loadAnimation({
              container: holder360,
              renderer: 'svg',
              loop: false,
              autoplay: false,
              path: cfg360.src,
              rendererSettings: { preserveAspectRatio: 'xMidYMid meet', progressiveLoad: false }
            });

            anim360.addEventListener('DOMLoaded', function () {
              if (settled) return;
              settled = true;
              clearTimeout(guard);
              frames360 = anim360.totalFrames || 0;
              if (!frames360) {
                fail360('animation reported no frames');
                return;
              }
              /* Taken from the animation itself, so the crop window holds its shape
                 whatever the render's dimensions — no ratio setting to fall out of
                 sync with the file. */
              var meta = anim360.animationData;
              if (meta && meta.w && meta.h) {
                r360.style.setProperty('--pm-360-ar', meta.w + ' / ' + meta.h);
              }
              shownFrame360 = -1;
              anim360.goToAndStop(0, true);
              ready360();
            });

            anim360.addEventListener('data_failed', function () {
              if (settled) return;
              settled = true;
              clearTimeout(guard);
              fail360('the JSON could not be parsed or fetched');
            });
          },
          function () {
            if (settled) return;
            settled = true;
            clearTimeout(guard);
            fail360('the Lottie player could not be fetched');
          }
        );
      }

      open360 = function () {
        r360.classList.add('is-open');
        r360.setAttribute('aria-hidden', 'false');
        document.body.classList.add('sych-pm-popup-open');

        build360();

        lastFrame = 0;
        idleAt = 0;
        if (!raf360) raf360 = requestAnimationFrame(tick360);
      };

      function close360() {
        r360.classList.remove('is-open');
        r360.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('sych-pm-popup-open');
        dragging360 = false;
        vel360 = 0;
        stage360.classList.remove('is-dragging');
        if (raf360) {
          cancelAnimationFrame(raf360);
          raf360 = null;
        }
      }

      r360.querySelectorAll('[data-pm-360-close]').forEach(function (el) {
        el.addEventListener('click', close360);
      });

      document.addEventListener('keydown', function (e) {
        if (!r360.classList.contains('is-open')) return;
        if (e.key === 'Escape') close360();
        if (!frames360) return;
        // a twenty-fourth of a turn per press, same as the video version
        if (e.key === 'ArrowLeft') {
          target360 -= frames360 / 24;
          stage360.classList.add('is-touched');
        }
        if (e.key === 'ArrowRight') {
          target360 += frames360 / 24;
          stage360.classList.add('is-touched');
        }
      });
    }

    var pillBtn = root.querySelector('[data-pm-popup-open]');
    if (pillBtn) {
      pillBtn.addEventListener('click', function () {
        if (r360) open360();
        else openPopup();
      });
    }

    /* ---------- Bundle total ---------- */

    var currency = root.dataset.currency || 'USD';
    var locale = root.dataset.locale || 'en';
    var mainPrice = parseInt(root.dataset.mainPrice, 10) || 0;
    var totalEl = root.querySelector('[data-pm-bundle-total]');
    var addonInputs = root.querySelectorAll('[data-pm-addon]');
    var formatter = null;

    try {
      formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
    } catch (err) {
      formatter = null;
    }

    function formatMoney(cents) {
      if (formatter) return formatter.format(cents / 100);
      return '$' + (cents / 100).toFixed(2);
    }

    function updateBundleTotal() {
      if (!totalEl) return;
      var total = mainPrice;
      addonInputs.forEach(function (input) {
        if (input.checked && input.dataset.price) {
          total += parseInt(input.dataset.price, 10) || 0;
        }
      });
      totalEl.textContent = formatMoney(total);
    }

    addonInputs.forEach(function (input) {
      input.addEventListener('change', updateBundleTotal);
    });

    if (mainPrice > 0) updateBundleTotal();

    /* ---------- Add to cart ---------- */

    /* NO TRACKING CODE LIVES HERE ANY MORE, AND THAT IS DELIBERATE.

       This section used to do two things for CustomerLabs: send its own combined
       add-to-cart event, and post /cart/add.js from inside a hidden same-origin
       iframe so CustomerLabs' fetch hook could not see the request and report one
       event per line item.

       That iframe could not tell trackers apart. Shopify's own web pixel detects
       cart adds the same way, so hiding from CustomerLabs also hid every add on
       this page from Shopify — and therefore from Meta, Google and everything else
       downstream. It is the reason AddToCart never reached Meta from the PDP.

       CustomerLabs has been removed, so both halves go with it. The plain fetch
       below is seen by Shopify's web pixel, which emits product_added_to_cart, and
       every connected pixel picks it up with no theme code involved.

       Known trade-off: a bundle now reports one add-to-cart per line item rather
       than a single combined event. That is what the combined CustomerLabs event
       existed to avoid. If a single bundle event is wanted again, publish a custom
       event here and subscribe to it from a custom pixel — do NOT reintroduce the
       iframe, and do not double up with product_added_to_cart. */

    var errorEl = root.querySelector('[data-pm-error]');

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    function addToCart(items, button) {
      if (!items.length || button.classList.contains('is-loading')) return;
      showError('');
      button.classList.add('is-loading');

      window.fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        credentials: 'same-origin', // cart cookie must ride along
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            showError(result.data.description || result.data.message || 'Something went wrong. Please try again.');
            return;
          }

          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function () {
          showError('Something went wrong. Please try again.');
        })
        .finally(function () {
          button.classList.remove('is-loading');
        });
    }

    var mainVariant = root.dataset.mainVariant;

    /* Purchase options. The radios come from the variant selling_plan_allocations
       rendered in sychedelic-product-main.liquid — Downpay deposits arrive as
       selling plans, and a plan only takes effect if its id rides along in the
       /cart/add.js payload. No radios (product has no plan assigned) means no
       selling_plan key, which is exactly the old behaviour. */
    var planInputs = root.querySelectorAll('[data-pm-plan]');

    function selectedPlan() {
      for (var i = 0; i < planInputs.length; i++) {
        if (planInputs[i].checked) {
          var planId = parseInt(planInputs[i].value, 10);
          return isNaN(planId) ? null : planId;
        }
      }
      return null;
    }

    function mainItem() {
      var item = { id: parseInt(mainVariant, 10), quantity: 1 };
      var planId = selectedPlan();
      if (planId) item.selling_plan = planId;
      return item;
    }
    var atcBtn = root.querySelector('[data-pm-atc]');
    var bundleBtn = root.querySelector('[data-pm-bundle]');

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (!mainVariant) return;
        addToCart([mainItem()], atcBtn);
      });
    }

    if (bundleBtn) {
      bundleBtn.addEventListener('click', function () {
        if (!mainVariant) return;
        /* Add-ons are separate products and carry no plan of their own; only the
           main variant takes the deposit. */
        var items = [mainItem()];

        addonInputs.forEach(function (input) {
          if (input.checked && input.dataset.variant) {
            items.push({ id: parseInt(input.dataset.variant, 10), quantity: 1 });
          }
        });

        addToCart(items, bundleBtn);
      });
    }
  });
});